import { render, staticRenderFns } from "./FormModalBody.vue?vue&type=template&id=2da708be&scoped=true&functional=true&"
import script from "./FormModalBody.vue?vue&type=script&lang=js&"
export * from "./FormModalBody.vue?vue&type=script&lang=js&"
import style0 from "./FormModalBody.vue?vue&type=style&index=0&id=2da708be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2da708be",
  null
  
)

export default component.exports